import React, { useEffect, useState } from "react";
import { Close, ArrowBack, ArrowForward, Delete } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import { LIVE_GAME_CHAT_CONTENT_TYPE } from "../../../../../../lib/constants/globalConstant";
import { deleteLiveGameMedia } from "../../../../../../redux/slices/liveGameSlice";
import { connect } from "react-redux";
import DeleteMediaModal from "../../../../../shared/Modals/DeleteMediaModal/DeleteMediaModal";
import play_button from '../../../../../../assets/svgs/play_video.svg';
import { storage } from "../../../../../../config/storage";
import { ImagePreviewStyles as styles } from "./chat.tailwind";

// const ImagePreview = ({
//     url,
//     index,
//     isFullScreen,
//     toggleFullScreen,
//     handleImageLoad,
//     // mediaLoaded,
// }) => {
//     const [isLoading, setIsLoading] = useState(true);

//     const handleLoad = () => {
//         setIsLoading(false);
//         handleImageLoad();
//     };
//     return (
//         <>
//             {isLoading && (
//                 <div
//                     className={`
//                         ${isFullScreen ? 'w-[90%] h-[90%]' : 'w-[150px] h-[120px]'} 
//                         bg-gray-700 animate-pulse rounded
//                     `}
//                 />
//             )}
//             <img
//                 src={url}
//                 alt='image'
//                 className={`
//                     ${isLoading ? 'opacity-0' : 'opacity-100'}
//                     ${isFullScreen ? 'max-w-[90%] max-h-[90%] transition-opacity duration-500' : `w-[150px] h-[120px] rounded shadow-lg transition-transform duration-500 object-cover cursor-pointer ${index === 0 ? "" : index === 1 ? "top-12 left-12" : "top-20 left-2"}`}
//                 `}
//                 // style={{ display: mediaLoaded ? "block" : "none" }}
//                 onClick={() => {
//                     if (!isFullScreen) {
//                         toggleFullScreen(index);
//                     }
//                 }}
//                 onLoad={handleLoad}
//             />
//         </>
//     );
// }

const ImagePreviewForLiveChat = ({ attachmentURLs, autoSlide = false, slideInterval = 3000, showControls = true, isUser, chatId, deleteMedia }) => {
    if (!attachmentURLs || attachmentURLs?.length === 0) return null;

    const universityId = storage.fetchFromLocalStorage.universityId();

    const [isFullScreen, setIsFullScreen] = useState(false);
    const [mediaLoadedStates, setMediaLoadedStates] = useState(
        new Array(attachmentURLs.length).fill(false)
    );
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [showDeleteModal, setshowDeleteModal] = useState(true);

    const toggleFullScreen = (initialIndex = 0) => {
        setCurrentImageIndex(initialIndex);
        setIsFullScreen(!isFullScreen);
    };

    const handleImageLoad = (index) => {
        setMediaLoadedStates((prevState) => {
            const newState = [...prevState];
            newState[index] = true; // Mark the specific media as loaded
            return newState;
        });
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % attachmentURLs?.length);
        setMediaLoadedStates((prevState) =>
            prevState.map((_, index) => (index === currentImageIndex ? false : _)) // Reset the loaded state for the next image
        );
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? attachmentURLs?.length - 1 : prevIndex - 1));
        setMediaLoadedStates((prevState) =>
            prevState.map((_, index) => (index === currentImageIndex ? false : _)) // Reset the loaded state for the previous image
        );
    };

    const handleDelete = async () => {

        const mediaId = attachmentURLs[currentImageIndex]?.mediaId;
     
        if (mediaId?.trim() === "" || !mediaId) return;

        try {
            const data = {
                mediaId,
                liveChatId: chatId,
                universityId
            }

            const response = await deleteMedia(data);
            if (deleteLiveGameMedia.fulfilled.match(response)) {
                setIsFullScreen(false);

                setshowDeleteModal(false);
                // const data = {
                //     universityId,
                //     chatId,
                //     mediaId,
                // }
                // await getMediaMessages(data)
                // setMediaMessages((prev) => {
                //     const previosMessages = [...prev];
                //     const remainingMessages = previosMessages?.filter((msg) => msg?._id !== mediaId);

                //     return remainingMessages;
                // })
            }
        } catch (error) {
            console.log("Something went wrong while deleting Image: ", error);
        }

    }

    useEffect(() => {
        if (autoSlide && isFullScreen) {
            const interval = setInterval(handleNextImage, slideInterval);
            return () => clearInterval(interval);
        }
    }, [autoSlide, slideInterval, isFullScreen]);

    useEffect(() => {
        if (isFullScreen) {
            document.body.style.overflow = "hidden";

            const handleKeyDown = (event) => {
                switch (event.key) {
                    case "Escape":
                        toggleFullScreen();
                        break;
                    case "ArrowRight":
                        attachmentURLs?.length !== 1 && handleNextImage();
                        break;
                    case "ArrowLeft":
                        attachmentURLs?.length !== 1 && handlePrevImage();
                        break;
                    default:
                        break;
                }
            };

            document.addEventListener("keydown", handleKeyDown);
            return () => {
                document.body.style.overflow = "auto";
                document.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [isFullScreen]);

    if (isFullScreen) {
        return (
            <div className={`${styles.fullScreenContainer}`}>
                <div className="flex gap-4">
                    {
                        isUser && (
                            <button onClick={()=> handleDelete()} className="absolute top-4 right-16 text-white p-1  border-box z-20 hover:bg-gray-200 hover:bg-opacity-20 duration-75 ease-in rounded-full">
                                {/* <Close fontSize="large" /> */}
                                <Delete fontSize="small" />
                            </button>
                        )
                    }
                    <button onClick={() => toggleFullScreen()} className="absolute top-4 right-4 text-white p-1  border-box z-20 hover:bg-gray-200 hover:bg-opacity-20 duration-75 ease-in rounded-full">
                        <Close fontSize="small" />
                    </button>
                </div>

                {(attachmentURLs?.length !== 1 && showControls) && (
                    <>
                        <button onClick={handlePrevImage} className="absolute left-4 text-white bg-black/50 p-3 rounded-full z-20">
                            <ArrowBack fontSize="large" />
                        </button>
                        <button onClick={handleNextImage} className="absolute right-4 text-white bg-black/50 p-3 rounded-full z-20">
                            <ArrowForward fontSize="large" />
                        </button>
                    </>
                )}

                {attachmentURLs[currentImageIndex]?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE ? (
                    <>
                        {!mediaLoadedStates[currentImageIndex] && (
                            <Skeleton variant="rounded" width="90%" height="90%" animation="wave" sx={{ bgcolor: "grey.700" }} />
                        )}
                        <img
                            src={attachmentURLs[currentImageIndex]?.url}
                            alt={`Full Screen ${currentImageIndex + 1}`}
                            className="max-w-[90%] max-h-[90%] transition-opacity duration-500 opacity-100"
                            style={{ display: mediaLoadedStates[currentImageIndex] ? "block" : "none" }}
                            onLoad={() => handleImageLoad(currentImageIndex)}
                        />
                    </>
                ) : (
                    <>
                        {mediaLoadedStates[currentImageIndex] && (
                            <Skeleton variant="rounded" width="90%" height="90%" animation="wave" sx={{ bgcolor: "grey.700" }} />
                        )}
                        <video
                            controls
                            alt={`Full Screen ${currentImageIndex + 1}`}
                            className="max-w-[90%] max-h-[90%] transition-opacity duration-500 opacity-100"
                            onLoadCapture={() => handleImageLoad(currentImageIndex)}
                            style={mediaLoadedStates[currentImageIndex] ? {display:'none'} : {display:'block'}}
                        >
                            <source src={attachmentURLs[currentImageIndex]?.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </>
                )}

                <div className="absolute bottom-4 bg-black/50 text-white px-4 py-2 rounded-full">
                    {currentImageIndex + 1} / {attachmentURLs?.length}
                </div>

            </div>
        );
    }

    return (
        <div className={styles.container}>
            {attachmentURLs?.length === 1 ? (
                attachmentURLs[0]?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE ? (
                    <>
                        {!mediaLoadedStates[0] && (
                            <Skeleton variant="rounded" width="100%" height="100%" animation="wave" sx={{ bgcolor: "grey.700" }} />
                        )}
                        <img
                            src={attachmentURLs[0]?.url}
                            alt="img"
                            onClick={() => toggleFullScreen(0)}
                            style={!mediaLoadedStates[currentImageIndex] ? {display:'none'} : {display:'block'}}
                            onLoad={() => handleImageLoad(0)}
                            className="w-full h-full rounded cursor-pointer object-cover"
                        />
                    </>
                ) : (
                    <div className="w-full h-full relative ">
                        {mediaLoadedStates[0] && (
                            <Skeleton variant="rounded" width="100%" height="100%" animation="wave" sx={{ bgcolor: "grey.700" }} />
                        )}
                        <video
                            controls={false}
                            alt="Video Preview"
                            onClick={() => toggleFullScreen(0)}
                            className="w-full h-full rounded cursor-pointer object-cover"
                            style={mediaLoadedStates[currentImageIndex] ? {display:'none'} : {display:'block'}}
                            onLoadedData={() => handleImageLoad(0)}
                        >
                            <source src={attachmentURLs[0]?.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div
                            className="absolute inset-0 flex items-center justify-center bg-black/40 cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleFullScreen(0);
                            }}
                        >
                            <img src={play_button} alt="Play Icon" />
                        </div>
                    </div>
                )
            ) : (
                <>
                    {attachmentURLs?.slice(0, 3).map((media, index) => (
                        media?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE ? (
                            <>
                                {!mediaLoadedStates[index] && (
                                    <Skeleton
                                        variant="rounded"
                                        animation="wave"
                                        className={`
                                            w-[100px] screen-500:w-[150px]
                                            ${attachmentURLs?.length === 1 ? `!h-[100px] screen-500:!h-[150px]` : `!h-[80px] screen-500:!h-[120px]`}
                                        `}
                                        sx={{
                                            position: 'absolute',
                                            bgcolor: "grey.700",
                                            top: index === 0 ? "" : index === 1 ? '3rem' : '5rem',
                                            left: index === 0 ? "" : index === 1 ? '3rem' : '0.5rem'
                                        }}
                                    />
                                )}
                                <img
                                    key={index}
                                    src={media?.url}
                                    alt={`img${index + 1}`}
                                    onClick={() => toggleFullScreen(index)}
                                    onLoad={() => handleImageLoad(index)}
                                    className={`absolute w-[100px] screen-500:w-[150px] ${attachmentURLs?.length === 2 ? 'h-[100px] screen-500:h-[150px]' : 'h-[80px] screen-500:h-[120px]'} rounded shadow-lg transition-transform duration-500 object-cover cursor-pointer ${index === 0 ? "" : index === 1 ? "top-12 left-12" : "top-20 left-2"} ${!mediaLoadedStates[index] ? 'opacity-0' : 'opacity-100'} `}
                                />
                            </>
                        ) : (
                            <div key={index} className={`absolute w-[100px] screen-500:w-[150px] ${attachmentURLs?.length === 2 ? 'h-[100px] screen-500:h-[150px]' : 'h-[80px] screen-500:h-[120px]'} rounded shadow-lg transition-transform duration-500 ${index === 0 ? "" : index === 1 ? "top-12 left-12" : "top-20 left-2"}`}>
                                {mediaLoadedStates[index] && (
                                    <Skeleton
                                        variant="rounded"
                                        className={`
                                            w-[100px] screen-500:w-[150px]
                                            ${attachmentURLs?.length === 1 ? `!h-[100px] screen-500:!h-[150px]` : `!h-[80px] screen-500:!h-[120px]`}
                                        `}
                                        animation="wave"
                                        sx={{
                                            // position: 'absolute',
                                            bgcolor: "grey.700",
                                            // top: index === 0 ? "" : index === 1 ? '3rem' : '0rem',
                                            // left: index === 0 ? "" : index === 1 ? '3rem' : '0rem'
                                        }}
                                    />
                                )}
                                <video
                                    alt="Video Preview"
                                    onClick={() => toggleFullScreen(index)}
                                    className="w-full h-full rounded cursor-pointer object-cover"
                                    style={mediaLoadedStates[currentImageIndex] ? {display:'none'} : {display:'block'}}
                                    onLoadedData={() => handleImageLoad(index)}
                                    controls={false}
                                >
                                    <source src={media?.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                <div
                                    className="absolute inset-0 flex items-center justify-center bg-black/40 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFullScreen(index);
                                    }}
                                >
                                    <img src={play_button} alt="Play Icon" />
                                </div>
                            </div>
                        )
                    ))}
                    {attachmentURLs?.length > 3 && (
                        <div
                            className={styles.view_more_skelton}
                            onClick={() => toggleFullScreen(2)}
                        >
                            + {attachmentURLs?.length - 3} more
                        </div>
                    )}
                </>
            )}
            {
                showDeleteModal && (
                    <DeleteMediaModal
                        isOpen={showDeleteModal}
                        onClose={setshowDeleteModal(false)}
                        handleDelete={handleDelete}
                    />
                )
            }
        </div>
    );

};

const mapDispatchToProps = (dispatch) => ({
    deleteMedia: (data) => dispatch(deleteLiveGameMedia(data)),
});

export default connect(null, mapDispatchToProps)(ImagePreviewForLiveChat);